import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

const AdminLogin = () => {
  const { t, setToken } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", form);
      setToken(res.data.access_token);
      toast.success("Welcome");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md card-tactile p-10 animate-fade-up">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-full bg-[#C95B24]/10 flex items-center justify-center">
            <Lock className="w-5 h-5 text-[#C95B24]" />
          </div>
          <h1 className="font-serif-display text-3xl text-[#1B4332]">{t("loginTitle")}</h1>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="login-email">{t("email")}</Label>
            <Input id="login-email" type="email" data-testid="admin-email-input" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="login-pass">{t("password")}</Label>
            <Input id="login-pass" type="password" data-testid="admin-password-input" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-2" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-btn" className="btn-forest rounded-full w-full py-6">
            {loading ? "..." : t("login")}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
